// extracted by mini-css-extract-plugin
module.exports = {"attributeWrapper":"AttributeWrapper_attributeWrapper__D9AoA"};